import { isPlatformBrowser } from '@angular/common';
import { Component, EventEmitter, HostListener, Inject, Input, OnInit, Output, PLATFORM_ID } from '@angular/core';
import { ButtonComponent } from '@banyan/modules/standalone/button/button.component';

@Component({
  selector: 'app-pagination',
  standalone: true,
  imports: [
    ButtonComponent,
  ],
  templateUrl: './pagination.component.html',
  styleUrl: './pagination.component.scss'
})
export class PaginationComponent implements OnInit {
  @Input() totalPages = 1;
  @Input() currentPage = 1;
  @Output() pageChange = new EventEmitter<number>();
  isMobile = false;

  constructor(@Inject(PLATFORM_ID) private readonly platformId: any) {
  }

  ngOnInit() {
    this.checkScreenSize();
  }

  @HostListener('window:resize')
  onResize() {
    this.checkScreenSize();
  }

  checkScreenSize() {
    if (isPlatformBrowser(this.platformId)) {
      this.isMobile = window.innerWidth <= 640;
    }
  }

  goToPage(page: any) {
    if (page !== this.currentPage && page >= 1 && page <= this.totalPages) {
      this.pageChange.emit(page);
    }
  }

  getPages(): (number | string)[] {
    const total = this.totalPages;
    const current = this.currentPage;
    if (total <= 7) {
      return Array.from({ length: total }, (_, i) => i + 1);
    }
    const first = 1;
    const last = total;
    if (current <= 3) {
      return [1, 2, 3, 4, '...', last - 1, last];
    }
    if (current === 4) {
      return [1, 2, 3, 4, 5, '...', last];
    }
    if (current >= total - 2) {
      return [first, '...', total - 4, total - 3, total - 2, total - 1, last];
    }
    if (current === total - 3) {
      return [first, '...', current - 1, current, current + 1, current + 2, last];
    }
    return [first, '...', current - 1, current, current + 1, '...', last];
  }

  getMobilePages(): (number | string)[] {
    const total = this.totalPages;
    const current = this.currentPage;
    if (total <= 3) {
      return Array.from({ length: total }, (_, i) => i + 1);
    }
    if (current <= 2) {
      return [1, 2, '...'];
    }
    if (current >= total - 1) {
      return ['...', total - 1, total];
    }
    return [current - 1, current, current + 1];
  }

  getPaginationPages(): (number | string)[] {
    return this.isMobile ? this.getMobilePages() : this.getPages();
  }


}
